// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"38":"9d337083db33855626c4","764":"9c1fdf94571acf134091"}[chunkId] + ".js";
};